import React from "react";
import { observer } from "mobx-react";
import { InputText } from "primereact/inputtext";
import { useFormik } from "formik";
import TooltipButton from "../../../../components/buttons/TooltipButton";
import { DeviceType } from "../../../../api/firebase/types/device.types";
import DeviceNameInput from "./fields/DeviceNameInput";

export type DeviceFormData = Pick<DeviceType, "name" | "serialNumber">;

type AddHardwareDeviceFormProps = {
  onSave: (deviceData: DeviceFormData) => void;
  showLoader: (loading: boolean) => void;
};

const AddHardwareDeviceForm: React.FC<AddHardwareDeviceFormProps> = (props) => {
  const formik = useFormik<DeviceFormData>({
    initialValues: {
      name: "",
      serialNumber: "",
    },
    validate: (data) => {
      let errors: Partial<DeviceFormData> = {};

      if (!data.name) {
        errors.name = "Bitte geben Sie der Meldeinstanz eine Bezeichnung";
      }
      if (!data.serialNumber || !(data.serialNumber.length === 15)) {
        errors.serialNumber =
          "Bitte geben Sie die 15-stellige Seriennummer des Geräts ein";
      }
      return errors;
    },
    onSubmit: (data) => {
      props.showLoader(true);
      props.onSave(data);
    },
  });

  const isFormFieldValid = (name: keyof DeviceFormData) =>
    !!(formik.touched[name] && formik.errors[name]);

  const getFormErrorMessage = (name: keyof DeviceFormData) =>
    isFormFieldValid(name) ? (
      <small className="p-error p-d-block form-error">
        {formik.errors[name]}
      </small>
    ) : undefined;

  return (
    <form
      className="p-formgrid p-grid"
      id="device-creation-modal"
      onSubmit={formik.handleSubmit}
    >
      <DeviceNameInput
        name={formik.values.name}
        onNameChange={formik.handleChange}
        errorMessage={getFormErrorMessage("name")}
      />
      <div className="p-field p-col-12">
        <label htmlFor="serialNumber">Seriennummer</label>
        <small>{"  "}15-stellig (S/N)</small>
        <TooltipButton tooltip="Die Seriennummer finden Sie auf dem Sticker an der Seite des Geräts. Bitte geben Sie alle drei Zeilen unterhalb der Kennzeichnung S/N ein (ohne Leerzeichen oder Umbruch)" />
        <InputText
          id="serialNumber"
          value={formik.values.serialNumber}
          onChange={formik.handleChange}
        />
        {getFormErrorMessage("serialNumber")}
      </div>
    </form>
  );
};

export default observer(AddHardwareDeviceForm);
